/* eslint-disable max-len */
/* eslint-disable no-console */
import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import { InfoTitle } from "../../../../components/InfoTitle";
import { SelectAutocomplete, Input, AutoSaveField as Field } from "../../../../components/Form";
import { MAX_SOURCE_OF_FUNDS_OTHERS_LENGTH } from "../../../../utils/validation";

import { OTHER_SOURCE_OF_WEALTH, SOURCE_OF_CAPITAL_WEALTH_LABEL } from "./constants";
import { Card } from "../../../../components/v2/Card/Card";

export const SignatorySourceOfFunds = ({ index, setFieldValue, values }) => {
  return (
    <Card title={SOURCE_OF_CAPITAL_WEALTH_LABEL}>
      <Grid container spacing={3}>
        <Grid item md={12} xs={12}>
          <Field
            multiple
            name="sourceOfWealth"
            path={`prospect.signatoryInfo[${index}].kycDetails.sourceOfWealth`}
            datalistId="wealthType"
            label={SOURCE_OF_CAPITAL_WEALTH_LABEL}
            placeholder={SOURCE_OF_CAPITAL_WEALTH_LABEL}
            onChange={selectedValue => {
              const withOption = selectedValue.includes(OTHER_SOURCE_OF_WEALTH);
              const sourceOfWealth = selectedValue.map(value => ({
                wealthType: value,
                others: withOption ? values.others : ""
              }));

              setFieldValue("sourceOfWealth", sourceOfWealth);
              if (!withOption) {
                setFieldValue("others", "");
              }
            }}
            extractValue={value => value.wealthType}
            contextualHelpText="Select the most prominent source of capital to fund the company"
            contextualHelpProps={{ isDisableHoverListener: false }}
            component={SelectAutocomplete}
            tabIndex="0"
            isSearchable
          />
          <InfoTitle title="You can select multiple values" />
        </Grid>
        <Grid
          className={cx({
            hidden: !(values.sourceOfWealth || [])
              .map(item => item.wealthType)
              .includes(OTHER_SOURCE_OF_WEALTH)
          })}
          item
          sx={{ mt: 3 }}
          xs={12}
        >
          <Field
            name="others"
            path={`prospect.signatoryInfo[${index}].kycDetails.sourceOfWealth[${values.sourceOfWealth.findIndex(
              element => element.wealthType === OTHER_SOURCE_OF_WEALTH
            )}].others`}
            label="Other (Specify)"
            placeholder="Other (Specify)"
            component={Input}
            InputProps={{
              inputProps: { maxLength: MAX_SOURCE_OF_FUNDS_OTHERS_LENGTH, tabIndex: 0 }
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

// PropTypes validation
SignatorySourceOfFunds.propTypes = {
  /** Index of the signatory in the array */
  index: PropTypes.number.isRequired,
  /** Function to update form field values */
  setFieldValue: PropTypes.func.isRequired,
  /** Form values object */
  values: PropTypes.shape({
    sourceOfWealth: PropTypes.arrayOf(
      PropTypes.shape({
        wealthType: PropTypes.string.isRequired,
        others: PropTypes.string
      })
    ).isRequired,
    others: PropTypes.string
  }).isRequired
};
